module.exports = __webpack_public_path__ + "img/banner-logo.dd0157ca.png";